@let t = text();

<section class="hd-moments-section">
  <h4 class="hd-moments-section__title">
    <span>{{ t.title }}</span>
    <span class="hd-moments-section__title-actions">
      @if (savedChartId()) {
        <button type="button" class="hd-moments-section__title-action"
                [attr.aria-label]="t.addMoment" [title]="t.addMoment"
                (click)="openLinkDialog()">
          <i class="fas fa-plus" aria-hidden="true"></i>
        </button>
        <!-- Levenstijdlijn-pagina van deze chart (stap 5); alleen op standaard charts (§2.6). -->
        @if (timelineAvailable()) {
          <button type="button" class="hd-moments-section__title-action"
                  [attr.aria-label]="t.timeline" [title]="t.timeline"
                  (click)="timelineRequested.emit(savedChartId()!)"
                  data-test-id="moments-section-timeline">
            <i class="fas fa-timeline" aria-hidden="true"></i>
          </button>
        }
        <!-- "Mijn mind zegt": het logboek-paneel, of (zonder notities) meteen een eerste mind-notitie. -->
        @if (mindCount() > 0) {
          <button type="button" class="hd-moments-section__title-action"
                  [attr.aria-label]="t.mindLog" [title]="t.mindLog"
                  (click)="mindLogRequested.emit(savedChartId()!)"
                  data-test-id="moments-section-mind-log">
            <i class="fas fa-brain" aria-hidden="true"></i>
          </button>
        } @else {
          <button type="button" class="hd-moments-section__title-action"
                  [attr.aria-label]="t.addMind" [title]="t.addMind"
                  (click)="openMindAdd()"
                  data-test-id="moments-section-mind-add">
            <i class="fas fa-brain" aria-hidden="true"></i>
          </button>
        }
        <!-- Markdown-export van alle momenten van deze chart (uitleg in de exportdialoog). -->
        @if (momentRows().length > 0) {
          <button type="button" class="hd-moments-section__title-action"
                  [attr.aria-label]="t.export" [title]="t.export"
                  (click)="openExport()"
                  data-test-id="moments-section-export">
            <i class="fas fa-file-export" aria-hidden="true"></i>
          </button>
        }
        <!-- Weergavekeuze lijst | kalender (beslispunt 10 + finetune 2026-09-21):
             expliciete knoppen, en een klik klapt een dichtgeklapte sectie open. -->
        <button type="button" class="hd-moments-section__title-action"
                [class.hd-moments-section__title-action--active]="expanded() && !calendarView()"
                [attr.aria-pressed]="expanded() && !calendarView()"
                [attr.aria-label]="t.list" [title]="t.list"
                (click)="showListView()"
                data-test-id="moments-section-list">
          <i class="fas fa-list" aria-hidden="true"></i>
        </button>
        <button type="button" class="hd-moments-section__title-action"
                [class.hd-moments-section__title-action--active]="expanded() && calendarView()"
                [attr.aria-pressed]="expanded() && calendarView()"
                [attr.aria-label]="t.calendar" [title]="t.calendar"
                (click)="showCalendarView()"
                data-test-id="moments-section-calendar">
          <i class="fas fa-calendar-days" aria-hidden="true"></i>
        </button>
      }
      <!-- Open-/dichtklappen helemaal rechts; standaard dichtgeklapt. -->
      <button type="button" class="hd-moments-section__title-action"
              [attr.aria-expanded]="expanded()"
              [attr.aria-label]="expanded() ? t.hide : t.show"
              [title]="expanded() ? t.hide : t.show"
              (click)="toggleExpanded()">
        <i class="fas fa-chevron-right hd-moments-section__chevron"
           [class.hd-moments-section__chevron--open]="expanded()"
           aria-hidden="true"></i>
      </button>
    </span>
  </h4>

  @if (expanded()) {
    @if (viewMode() !== 'owner') {
      <!-- Gedeelde chart (spec 2026-10-20-chart-share §4.5): geen momenten, ook niet ingelogd. -->
      <div class="hd-moments-section__empty" data-test-id="moments-shared-unavailable">{{ t.sharedUnavailable }}</div>
    } @else if (!savedChartId()) {
      <div class="hd-moments-section__empty">{{ t.saveFirst }}</div>
    } @else if (loading()) {
      <div class="hd-moments-section__empty">{{ t.loading }}</div>
    } @else if (error()) {
      <div class="hd-moments-section__error">{{ error() }}</div>
    } @else if (calendarView()) {
      <!-- Kalenderweergave: openen = mét Notities-paneel; toevoegen = daily voorgeselecteerd. -->
      <hd-moments-calendar
        [markers]="calendarMarkers()"
        compact
        (openRequested)="chartOpenWithNotesRequested.emit($event)"
        (consultationOpenRequested)="openConsultation($event)"
        (editRequested)="openMomentEdit($event)"
        (addRequested)="openCalendarAdd($event)"
      ></hd-moments-calendar>
    } @else if (momentRows().length === 0 && momentOfRows().length === 0) {
      <div class="hd-moments-section__empty">{{ t.none }}</div>
    } @else {
      @for (row of visibleMomentRows(); track row.relation.id) {
        <div class="hd-moments-section__row">
          @if (row.relation.otherChartId; as editChartId) {
            <button type="button" class="hd-moments-section__row-edit"
                    [attr.aria-label]="t.edit" [title]="t.edit"
                    (click)="openMomentEdit(editChartId)"
                    data-test-id="moments-row-edit">
              <i class="fas fa-pen" aria-hidden="true"></i>
            </button>
          }
          <button type="button" class="hd-moments-section__moment"
                  [disabled]="!row.relation.otherChartId"
                  (click)="openRow(row)">
            @if (row.colorHex) {
              <span class="hd-moments-section__color-dot" [style.background]="row.colorHex"></span>
            }
            <i [class]="'fas fa-' + row.icon + ' hd-moments-section__icon'" aria-hidden="true"></i>
            <span class="hd-moments-section__name">{{ row.name }}</span>
            <!-- Alleen indicatoren: de notitie zelf hoort in het Notities-paneel. -->
            @if (row.hasNote) {
              <i class="fas fa-note-sticky hd-moments-section__note-indicator" [title]="t.hasNote" aria-hidden="true"></i>
            }
            @if (row.attachmentCount > 0) {
              <span class="hd-moments-section__attachment-indicator" [title]="t.hasAttachments">
                <i class="fas fa-paperclip" aria-hidden="true"></i>{{ row.attachmentCount }}
              </span>
            }
            @if (row.momentText) {
              <span class="hd-moments-section__moment-text">{{ row.momentText }}</span>
            }
          </button>
        </div>
      }
      @if (hiddenRowCount() > 0) {
        <button type="button" class="hd-moments-section__show-all" (click)="openMomentsDialog()">
          {{ t.showAll }} ({{ momentRows().length }})
        </button>
      }
      @if (momentOfRows().length > 0) {
        <div class="hd-moments-section__moment-of-title">{{ t.momentOfTitle }}</div>
        @for (row of momentOfRows(); track row.relation.id) {
          <div class="hd-moments-section__row">
            <button type="button" class="hd-moments-section__moment"
                    [disabled]="!row.relation.otherChartId"
                    (click)="openRow(row)">
              <i [class]="'fas fa-' + row.icon + ' hd-moments-section__icon'" aria-hidden="true"></i>
              <span class="hd-moments-section__name">{{ row.name }}</span>
              @if (row.hasNote) {
                <i class="fas fa-note-sticky hd-moments-section__note-indicator" [title]="t.hasNote" aria-hidden="true"></i>
              }
              @if (row.attachmentCount > 0) {
                <span class="hd-moments-section__attachment-indicator" [title]="t.hasAttachments">
                  <i class="fas fa-paperclip" aria-hidden="true"></i>{{ row.attachmentCount }}
                </span>
              }
            </button>
          </div>
        }
      }
    }
  }
</section>

<hd-moment-link-dialog
  [(target)]="linkDialogTarget"
  [sourcePreset]="preset()"
  [prefillDateUtc]="linkDialogPrefillUtc()"
  [prefillWithTime]="linkDialogCategory() === 'mind'"
  [defaultCategory]="linkDialogCategory()"
  [initialMode]="linkDialogInitialMode()"
  (changed)="onLinkChanged()"
  (chartCreated)="chartOpenRequested.emit($event)"
  (ichingRequested)="onIChingRequested($event)"
></hd-moment-link-dialog>

<!-- I Tjing-moment lezen (sectie-kalender) of een nieuwe raadpleging starten (derde keuze). -->
<hd-iching-moment-dialog [(target)]="ichingDialogTarget"></hd-iching-moment-dialog>

<hd-moments-dialog
  [(target)]="momentsDialogTarget"
  [rows]="momentRows()"
  (chartOpenRequested)="chartOpenRequested.emit($event)"
></hd-moments-dialog>

<!-- Momentdetails bewerken (potlood op rij of sectie-kalender, finetune 2026-09-21). -->
<hd-chart-edit-dialog
  [(target)]="editDialogTarget"
  [showMyChart]="false"
  (saved)="onMomentEditSaved($event)"
></hd-chart-edit-dialog>

<!-- Markdown-export van de momenten van deze chart. -->
<hd-moments-export-dialog [(target)]="exportTarget"></hd-moments-export-dialog>
